var _defs, _path, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectiveInvoicesReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.17 54.15h-17.7V37.48a8.86 8.86 0 0117.7 0zM51.56 28.76h70.99M153.71 122.42v16.34H43.34v-16.34M153.71 122.42V75.26l-17.54-12.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.2 63.47L43.34 75.26v47.16M60.2 86.89V54.15M136.17 87.19v-24.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M153.71 75.26l-17.54 11.93-16.09 10.93-.96.64-14.51 9.88-5.86 3.98-.64.44-6.41-4.42-14.26-9.85-17.24-11.9-16.86-11.63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M90.25 80.01H73.96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M125.77 24.72a22 22 0 1124.29 34.33M149.79 59.14L104.3 71.61l-2.72 3.75-6.74-4.68 30.77-45.73"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 143.38,
    cy: 37.94,
    r: 13.98
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M108.62 63.42l22.32-32.07"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 143.38,
    cy: 37.61,
    r: 2.76
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M94.66 70.98l.04 6.13 6.71-1.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectiveInvoicesReceived);
export default __webpack_public_path__ + "static/media/correctiveInvoicesReceived.463eca7b4e1fb3277e89cc9cdda1a941.svg";
export { ForwardRef as ReactComponent };